import React from "react";
import Select from "react-select";
import { commonSelectProps } from "../../../components/shared/SelectStyles";

const OrderInfoTab = ({
    orderData,
    orderInfo,
    handleOrderInfoChange,
    handleSaveOrderInfo,
    artistsData,
    producersData,
    installersData,
    purchasersData,
    productionManagersData,
    cashiersData,
    showIndoorSalesman = false,
    indoorSalesmanOptions = [],
    superadmin,
    manager,
    outright,
    staff,
}) => {
    return (
        <div className="p-6">
            <h2 className="text-xl font-bold mb-4">Order Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* First Column - Invoice ID and Order Status/Payment Details */}
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Invoice ID
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.invoiceId || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Order Status
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            <span
                                className={`px-2 py-1 rounded text-sm font-medium ${
                                    orderData.status === "completed"
                                        ? "bg-green-100 text-green-800"
                                        : orderData.status?.status === "pending"
                                        ? "bg-yellow-100 text-yellow-800"
                                        : "bg-gray-100 text-gray-800"
                                }`}
                            >
                                {orderData.status || "N/A"}
                            </span>
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Payment Type
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.paymentType || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Total Amount
                        </label>
                        <div className="p-2 bg-gray-50 rounded border font-bold text-lg">
                            {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                ? "$"
                                : "RM"}
                            {orderData?.amount
                                ? new Intl.NumberFormat("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  }).format(orderData?.amount || 0)
                                : "0.00"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Discount
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                ? "$"
                                : "RM"}
                            {orderData?.discount
                                ? new Intl.NumberFormat("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  }).format(orderData?.discount || 0)
                                : "0.00"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            CO Number
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.coNumber || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Estimated Installation Days
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.estimatedInstallationDays || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Deposit
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                ? "$"
                                : "RM"}
                            {orderData?.deposit
                                ? new Intl.NumberFormat("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  }).format(orderData?.deposit || 0)
                                : "0.00"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Address Line 1 *
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={orderInfo.lineOne || ""}
                            onChange={(e) =>
                                handleOrderInfoChange("lineOne", e.target.value)
                            }
                            placeholder="Enter Address Line 1"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Address Line 2
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={orderInfo.lineTwo || ""}
                            onChange={(e) =>
                                handleOrderInfoChange("lineTwo", e.target.value)
                            }
                            placeholder="Enter Address Line 2"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Postal Code *
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={orderInfo.zip || ""}
                            onChange={(e) =>
                                handleOrderInfoChange("zip", e.target.value)
                            }
                            placeholder="Enter Postal Code"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            City *
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={orderInfo.city || ""}
                            onChange={(e) =>
                                handleOrderInfoChange("city", e.target.value)
                            }
                            placeholder="Enter City"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            State *
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={orderInfo.country || ""}
                            onChange={(e) =>
                                handleOrderInfoChange("country", e.target.value)
                            }
                            placeholder="Enter State"
                        />
                    </div>
                </div>

                {/* Second Column - Date Fields (in correct sequence) */}
                <div className="space-y-4">
                    {(superadmin || manager || outright) && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Order Status
                            </label>
                            <div className="react-select-container">
                                <Select
                                    options={[
                                        { label: "Draft", value: "draft" },
                                        { label: "Pending", value: "pending" },
                                        { label: "Completed", value: "completed" },
                                        { label: "Failed", value: "failed" },
                                        { label: "Uploaded Draft", value: "uploadedDraft" },
                                        { label: "Pending Salesman Draft", value: "pendingSalesmanDraft" },
                                        { label: "Pending Customer Draft", value: "pendingCustomerDraft" },
                                        { label: "Draft Approved", value: "draftApproved" },
                                        { label: "Purchasing", value: "purchasing" },
                                        { label: "Purchase Approved", value: "purchaseApproved" },
                                        { label: "Production", value: "production" },
                                        { label: "Production Approved", value: "productionApproved" },
                                        { label: "Installing", value: "installing" },
                                        { label: "Install Approved", value: "installApproved" },
                                    ]}
                                    value={
                                        orderInfo.status
                                            ? {
                                                  label: orderInfo.status
                                                      .replace(/([A-Z])/g, " $1")
                                                      .replace(/^./, (str) => str.toUpperCase())
                                                      .trim(),
                                                  value: orderInfo.status,
                                              }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        handleOrderInfoChange(
                                            "status",
                                            selected ? selected.value : null
                                        )
                                    }
                                    placeholder="Select Status"
                                    {...commonSelectProps}
                                />
                            </div>
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Purchase Date *
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.createdAt
                                    ? new Date(orderInfo.createdAt)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Commence Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.commenceDate
                                    ? new Date(orderInfo.commenceDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Upload Draft Date
                            </label>
                            <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                                value={
                                    orderInfo.uploadedDraftDate
                                        ? new Date(orderInfo.uploadedDraftDate)
                                              .toISOString()
                                              .split("T")[0]
                                        : ""
                                }
                                readOnly
                            />
                        </div>
                    )}
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Blueprint Approval Date
                            </label>
                            <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                                value={
                                    orderInfo.blueprintApprovalDate
                                        ? new Date(orderInfo.blueprintApprovalDate)
                                              .toISOString()
                                              .split("T")[0]
                                        : ""
                                }
                                readOnly
                            />
                        </div>
                    )}
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Salesman Approved Date
                                </label>
                                <input
                                    type="text"
                                    className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                                    value={
                                        orderInfo.salesmanApprovedDate
                                            ? new Date(orderInfo.salesmanApprovedDate)
                                                  .toISOString()
                                                  .split("T")[0]
                                            : ""
                                    }
                                    readOnly
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Salesman Rejected Date
                                </label>
                                <input
                                    type="text"
                                    className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                                    value={
                                        orderInfo.salesmanRejectedDate
                                            ? new Date(orderInfo.salesmanRejectedDate)
                                                  .toISOString()
                                                  .split("T")[0]
                                            : ""
                                    }
                                    readOnly
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Customer Approved Date
                                </label>
                                <input
                                    type="text"
                                    className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                                    value={
                                        orderInfo.customerApprovedDate
                                            ? new Date(orderInfo.customerApprovedDate)
                                                  .toISOString()
                                                  .split("T")[0]
                                            : ""
                                    }
                                    readOnly
                                />
                            </div>
                        </>
                    )}
                
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Purchasing Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.purchasingDate
                                    ? new Date(orderInfo.purchasingDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Production Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.productionDate
                                    ? new Date(orderInfo.productionDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Production Approval Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.productionApprovalDate
                                    ? new Date(orderInfo.productionApprovalDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Installing Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.installingDate
                                    ? new Date(orderInfo.installingDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Survey Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.installApprovedDate
                                    ? new Date(orderInfo.installApprovedDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Completion Date
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
                            value={
                                orderInfo.commenceDate
                                    ? new Date(orderInfo.commenceDate)
                                          .toISOString()
                                          .split("T")[0]
                                    : ""
                            }
                            readOnly
                        />
                    </div>
                </div>

                {/* Team Assignment */}
                <div className="space-y-4">
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Drafter *
                            </label>
                            <div className="react-select-container">
                                <Select
                                    options={artistsData.map((user) => ({
                                        label: user.name,
                                        value: user._id,
                                    }))}
                                    value={
                                        orderInfo.artist
                                            ? {
                                                  label: orderInfo.artist.name,
                                                  value: orderInfo.artist._id,
                                              }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        handleOrderInfoChange(
                                            "artist",
                                            selected
                                                ? {
                                                      name: selected.label,
                                                      _id: selected.value,
                                                  }
                                                : null
                                        )
                                    }
                                    placeholder="Select Drafter"
                                    isClearable
                                    {...commonSelectProps}
                                />
                            </div>
                        </div>
                    )}
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    3D Print Required
                                </label>
                                <div className="react-select-container">
                                    <Select
                                        options={[
                                            { label: "False", value: false },
                                            { label: "True", value: true },
                                        ]}
                                        value={
                                            orderInfo.threeDPrint
                                                ? { label: "True", value: true }
                                                : { label: "False", value: false }
                                        }
                                        onChange={(selected) =>
                                            handleOrderInfoChange(
                                                "threeDPrint",
                                                selected ? selected.value : false
                                            )
                                        }
                                        placeholder="Select 3D Print Status"
                                        {...commonSelectProps}
                                    />
                                </div>
                            </div>
                            {orderInfo.threeDPrint && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        3D Expenses
                                    </label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={orderInfo.threedDrawing || 0}
                                        onChange={(e) =>
                                            handleOrderInfoChange(
                                                "threedDrawing",
                                                parseFloat(e.target.value) || 0
                                            )
                                        }
                                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="0.00"
                                    />
                                </div>
                            )}
                        </>
                    )}
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Production Manager
                            </label>
                            <div className="react-select-container">
                                <Select
                                    options={productionManagersData.map((user) => ({
                                        label: user.name,
                                        value: user._id,
                                    }))}
                                    value={
                                        orderInfo.productionManager
                                            ? {
                                                  label: orderInfo.productionManager.name,
                                                  value: orderInfo.productionManager._id,
                                              }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        handleOrderInfoChange(
                                            "productionManager",
                                            selected
                                                ? {
                                                      name: selected.label,
                                                      _id: selected.value,
                                                  }
                                                : null
                                        )
                                    }
                                    placeholder="Select Production Manager"
                                    isClearable
                                    {...commonSelectProps}
                                />
                            </div>
                        </div>
                    )}
                    {process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Purchaser *
                                </label>
                                <div className="react-select-container">
                                    <Select
                                        options={purchasersData.map((user) => ({
                                            label: user.name,
                                            value: user._id,
                                        }))}
                                        value={
                                            orderInfo.purchaser
                                                ? {
                                                      label: orderInfo.purchaser.name,
                                                      value: orderInfo.purchaser._id,
                                                  }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleOrderInfoChange(
                                                "purchaser",
                                                selected
                                                    ? {
                                                          name: selected.label,
                                                          _id: selected.value,
                                                      }
                                                    : null
                                            )
                                        }
                                        placeholder="Select Purchaser"
                                        isClearable
                                        {...commonSelectProps}
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Producer *
                                </label>
                                <div className="react-select-container">
                                    <Select
                                        options={producersData.map((user) => ({
                                            label: user.name,
                                            value: user._id,
                                        }))}
                                        value={
                                            orderInfo.producer
                                                ? {
                                                      label: orderInfo.producer.name,
                                                      value: orderInfo.producer._id,
                                                  }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleOrderInfoChange(
                                                "producer",
                                                selected
                                                    ? {
                                                          name: selected.label,
                                                          _id: selected.value,
                                                      }
                                                    : null
                                            )
                                        }
                                        placeholder="Select Producer"
                                        isClearable
                                        {...commonSelectProps}
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Installer *
                                </label>
                                <div className="react-select-container">
                                    <Select
                                        options={installersData.map((user) => ({
                                            label: user.name,
                                            value: user._id,
                                        }))}
                                        value={
                                            orderInfo.installer
                                                ? {
                                                      label: orderInfo.installer.name,
                                                      value: orderInfo.installer._id,
                                                  }
                                                : null
                                        }
                                        onChange={(selected) =>
                                            handleOrderInfoChange(
                                                "installer",
                                                selected
                                                    ? {
                                                          name: selected.label,
                                                          _id: selected.value,
                                                      }
                                                    : null
                                            )
                                        }
                                        placeholder="Select Installer"
                                        isClearable
                                        {...commonSelectProps}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Salesman *
                        </label>
                        <div className="react-select-container">
                            <Select
                                options={cashiersData.map((user) => ({
                                    label: `${user.phoneNumber} - ${user.name}`,
                                    value: user._id,
                                }))}
                                value={
                                    orderInfo.cashier
                                        ? {
                                              label: `${orderInfo.cashier.phoneNumber} - ${orderInfo.cashier.name}`,
                                              value: orderInfo.cashier._id,
                                          }
                                        : null
                                }
                                onChange={(selected) =>
                                    handleOrderInfoChange(
                                        "cashier",
                                        selected
                                            ? {
                                                  name: selected.label.split(
                                                      " - "
                                                  )[1],
                                                  phoneNumber:
                                                      selected.label.split(
                                                          " - "
                                                      )[0],
                                                  _id: selected.value,
                                              }
                                            : null
                                    )
                                }
                                placeholder="Select Agent"
                                isClearable
                                {...commonSelectProps}
                            />
                        </div>
                    </div>
                    {showIndoorSalesman && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Indoor Salesman
                            </label>
                            <div className="react-select-container">
                                <Select
                                    options={indoorSalesmanOptions}
                                    value={
                                        indoorSalesmanOptions.find(
                                            (opt) => opt.value === orderInfo.secondSalesperson
                                        ) || null
                                    }
                                    onChange={(selected) =>
                                        handleOrderInfoChange(
                                            "secondSalesperson",
                                            selected ? selected.value : ""
                                        )
                                    }
                                    placeholder="Select Indoor Salesman"
                                    {...commonSelectProps}
                                    isClearable
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Remarks */}
            {orderData?.remark && (
                <div className="mt-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Remarks
                    </label>
                    <div className="p-3 bg-gray-50 rounded border">
                        {orderData?.remark || "N/A"}
                    </div>
                </div>
            )}

            {/* Extra Warranty */}
            {orderData?.extraWarranty && (
                <div className="mt-6">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Extra Warranty
                    </label>
                    <div className="p-3 bg-gray-50 rounded border">
                        {orderData?.extraWarranty || "N/A"}
                    </div>
                </div>
            )}

            {/* Save Button */}
            {!staff && (
                <div className="mt-6 flex justify-end">
                    <button
                        onClick={handleSaveOrderInfo}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium"
                    >
                        Save Order Information
                    </button>
                </div>
            )}
        </div>
    );
};

export default OrderInfoTab;
